import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useCallback, useEffect, useRef } from 'react';
import classnames from 'classnames';
import { FormattedMessage as Translation } from 'react-intl';
var css = {
  "tabs": "oalp-2E9ZU",
  "tab": "oalp-1BfRZ",
  "tab_title": "oalp-DDcSs",
  "selected_tab_title": "oalp-321F7",
  "card": "oalp-XKEyp",
  "card_title": "oalp-11IN3",
  "selected_card_title": "oalp-19pUR",
  "selectedBorder": "oalp-AalIL"
};
import ImageWrapper from "../ImageWrapper/ImageWrapper";
import DependencyManager from "../../DependencyManager";
export var Tabs = function Tabs(_ref) {
  var _ref$tabsData = _ref.tabsData,
    tabsData = _ref$tabsData === void 0 ? [] : _ref$tabsData,
    selectedTab = _ref.selectedTab,
    onTabClick = _ref.onTabClick,
    _ref$tabClassName = _ref.tabClassName,
    tabClassName = _ref$tabClassName === void 0 ? '' : _ref$tabClassName,
    _ref$selectedTabClass = _ref.selectedTabClassName,
    selectedTabClassName = _ref$selectedTabClass === void 0 ? '' : _ref$selectedTabClass,
    _ref$tabsClassName = _ref.tabsClassName,
    tabsClassName = _ref$tabsClassName === void 0 ? '' : _ref$tabsClassName,
    tabTextStyle = _ref.tabTextStyle;
  var PanameraConstants = DependencyManager.getDependency('constants');
  var tabRef = useRef(null);
  var onTabClickHandler = useCallback(function (event) {
    var _event$currentTarget = event.currentTarget,
      _event$currentTarget2 = _event$currentTarget === void 0 ? {} : _event$currentTarget,
      _event$currentTarget3 = _event$currentTarget2.id,
      index = _event$currentTarget3 === void 0 ? null : _event$currentTarget3;
    if (index) {
      onTabClick(tabsData[parseInt(index, 10)]);
    }
  }, [onTabClick, tabsData]);
  var handleScroll = useCallback(function (event) {
    var tab = tabRef.current;
    if (tab) {
      tab.scroll({
        left: event.target.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(function () {
    var tabContainers = tabRef.current;
    if (PanameraConstants.platform === 'mobile') {
      if (tabContainers) {
        tabContainers.addEventListener('click', handleScroll);
      }
    }
    return function () {
      if (tabContainers) {
        tabContainers.removeEventListener('click', handleScroll);
      }
    };
  }, [handleScroll, PanameraConstants.platform]);
  if (tabsData && tabsData.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(_defineProperty(_defineProperty({}, css.tabs, !tabsClassName), tabsClassName, tabsClassName)),
      "data-aut-id": "carousel-list",
      ref: tabRef
    }, tabsData.map(function (tab, index) {
      var title = tab.title,
        defaultTitleMessage = tab.defaultTitleMessage,
        key = tab.key,
        icon = tab.icon,
        selectedIcon = tab.selectedIcon;
      var selected = key === selectedTab;
      var isCard = !!icon;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(css.tab, _defineProperty({}, css.selected, selected)),
        onClick: onTabClickHandler,
        key: index,
        id: "".concat(index)
      }, /*#__PURE__*/React.createElement("div", {
        className: isCard ? css.card : ''
      }, icon && (/*#__PURE__*/React.createElement(ImageWrapper, {
        image: selected && selectedIcon ? selectedIcon : icon
      })), /*#__PURE__*/React.createElement("div", {
        className: classnames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, css.card_title, isCard), css.selected_card_title, isCard && selected), css.tab_title, !isCard && !tabClassName), tabClassName, !isCard && tabClassName), css.selected_tab_title, !isCard && selected && !selectedTabClassName), selectedTabClassName, !isCard && selected && selectedTabClassName)),
        style: tabTextStyle
      }, /*#__PURE__*/React.createElement(Translation, {
        id: title,
        defaultMessage: defaultTitleMessage
      }))), selected && /*#__PURE__*/React.createElement("div", {
        className: css.selectedBorder
      }));
    }));
  }
  return null;
};
export default Tabs;